// extracted by mini-css-extract-plugin
export default {"chip":"MGChip_chip__o-yq2","label":"MGChip_label__mUSj8","iconLeft":"MGChip_iconLeft__QtvUL","iconRight":"MGChip_iconRight__U28JO"};